import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import D6utils from "./d6_utils"
import axios from 'axios'
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import Lottie from 'vue-lottie'

Vue.component('lottie',Lottie)
Vue.use(VueToast);

Vue.config.productionTip = false
Vue.prototype.$rest = D6utils(store,Vue,axios)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
